import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

 const ProtectedRoute = ({ children }) => {
  const token = useSelector((state) => state.user.logintoken);
  console.log("protectedroute",token)

  return token ? children : <Navigate to="/sal" />;
};
export default ProtectedRoute
